/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ArrowDownFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M3.70711 9.87868C3.31658 9.48816 2.68342 9.48816 2.29289 9.87868C1.90237 10.2692 1.90237 10.9024 2.29289 11.2929L12 21L21.7071 11.2929C22.0976 10.9024 22.0976 10.2692 21.7071 9.87868C21.3166 9.48816 20.6834 9.48816 20.2929 9.87868L13 17.1716L13 4C13 3.44771 12.5523 3 12 3C11.4477 3 11 3.44771 11 4L11 17.1716L3.70711 9.87868Z" />
      </svg>
    </Icon>
  );
});

export { ArrowDownFillIcon };
